/*
  Module configuration file
 */
import { JsonObject, JsonProperty } from "typescript-json-serializer";
import {ModuleConfiguration} from "../core/config/module-configuration";
import {TopicConfiguration} from "./topic-configuration";
import {FeatureLayerConfiguration} from "../core/config/layer-configuration";
import {PopupConfiguration} from "../core/config/popup-configuration";
import {LayerListConfiguration} from "../core/config/layer-list-configuration";
import {WebMapConfiguration} from "../core/config/web-map-configuration";
import {
    FillSymbolConfiguration,
    PictureMarkerSymbolConfiguration
} from "../core/config/symbol-configuration";
import {MaintenanceConfiguration} from "../core/config/maintenance-configuration";
import {MessageConfiguration} from "../core/config/message-configuration";
import {BookmarkConfiguration} from "../core/config/bookmark-configuration";

@JsonObject()
export class WebMapMetaConfiguration extends ModuleConfiguration {
    @JsonProperty()
    declare alerts?: MessageConfiguration[];
    constructor() {
        super();
    }
}

@JsonObject()
export class SymbolConfiguration {
    @JsonProperty()
    declare highlight: __esri.SimpleFillSymbolProperties;

    @JsonProperty()
    declare highlight_text: __esri.TextSymbolProperties;

    @JsonProperty()
    declare sketch: __esri.SimpleFillSymbolProperties;

    @JsonProperty()
    declare sketch_text: __esri.TextSymbolProperties;

    constructor() {
    }
}

@JsonObject()
export class MapViewerConfiguration extends ModuleConfiguration {
    @JsonProperty()
    declare bookmarks: BookmarkConfiguration[];

    @JsonProperty()
    declare breakpoints: {
        [key: string]: number;
    };
    // the topic activated on application's start
    @JsonProperty()
    declare initialTopic: string;

    /**
     * Layer list configuration
     */
    @JsonProperty()
    declare layerList: LayerListConfiguration;

    /**
     * Layer configurations (e.g. station layer)
     */
    @JsonProperty()
    declare layers: FeatureLayerConfiguration[];

    /**
     * Information about maintenance work on the application
     */
    @JsonProperty({ type: MaintenanceConfiguration})
    declare maintenance?: MaintenanceConfiguration[];

    // Objektabfrage Popup
    @JsonProperty()
    declare popup: PopupConfiguration;

    // Visualizing of features
    @JsonProperty()
    declare symbols: SymbolConfiguration;

    // Objektabfrage Highlight
    @JsonProperty()
    declare highlightSymbol: FillSymbolConfiguration;

    @JsonProperty()
    declare pointerSymbols?: HashMap<PictureMarkerSymbolConfiguration>;

    @JsonProperty()
    declare webMap: WebMapConfiguration;

    @JsonProperty()
    declare meta: WebMapMetaConfiguration;

    @JsonProperty()
    declare htmlContent: HashMap<string | HashMap<string>>;
    /**
     * Enable or disable search field in locate button
     *
     * @default true
     */
    @JsonProperty()
    locateButtonEnabled = true;

    constructor() {
        super();
    }
}
